import type { GetBuildingDocumentStorageUsageResponse } from '@quipex/shared/contracts';

export type DocumentStorageCapacityStatus = 'normal' | 'almost-full' | 'full';

const BYTES_PER_KILOBYTE = 1_000;
const BYTES_PER_MEGABYTE = 1_000_000;
const BYTES_PER_GIGABYTE = 1_000_000_000;

export function formatDocumentStorageBytes(bytes: number): string {
    if (bytes < BYTES_PER_KILOBYTE) return `${Math.round(bytes)} B`;
    if (bytes < BYTES_PER_MEGABYTE) {
        return `${Math.round(bytes / BYTES_PER_KILOBYTE)} KB`;
    }
    if (bytes < BYTES_PER_GIGABYTE) {
        return `${Math.round(bytes / BYTES_PER_MEGABYTE)} MB`;
    }

    return `${Number((bytes / BYTES_PER_GIGABYTE).toFixed(2))} GB`;
}

export function getDocumentStorageCapacityStatus(
    usage: GetBuildingDocumentStorageUsageResponse | null | undefined
): DocumentStorageCapacityStatus {
    if (
        !usage ||
        !Number.isFinite(usage.usedBytes) ||
        !Number.isFinite(usage.limitBytes) ||
        usage.usedBytes < 0 ||
        usage.limitBytes <= 0
    ) {
        return 'normal';
    }

    const ratio = usage.usedBytes / usage.limitBytes;
    if (ratio >= 1) return 'full';
    if (ratio >= 0.9) return 'almost-full';
    return 'normal';
}
